<template>
  <div class="checkbox-header-container">
    <input
      v-indeterminate="isIndeterminate"
      type="checkbox"
      class="header-checkbox"
      :checked="isAllSelected"
      @change="handleToggle"
    >
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  isAllSelected?: boolean
  isIndeterminate?: boolean
}>(), {
  isAllSelected: false,
  isIndeterminate: false
})

const emit = defineEmits<{
  (e: 'toggle-all', payload: { checked: boolean }): void
}>()

const vIndeterminate = {
  mounted(el: HTMLInputElement, binding: { value: boolean }) {
    el.indeterminate = binding.value
  },
  updated(el: HTMLInputElement, binding: { value: boolean }) {
    el.indeterminate = binding.value
  }
}

function handleToggle(event: Event) {
  const checked = (event.target as HTMLInputElement).checked
  emit('toggle-all', { checked: !!checked })
}
</script>

<style scoped lang="scss">

.checkbox-header-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.header-checkbox {
  cursor: pointer;
  width: 14px;
  height: 14px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: transparent;
  position: relative;
  
  &:indeterminate {
    background-color: $titleText;
    border-color: $titleText;

    &::before {
      content: none;
      display: none;
    }

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 7.5px;
      height: 1px;
      background-color: $white;
      border-radius: 1px;
    }
  }
}
</style>